export const CUSTOM_COLOR_REGEX = /^color-(\d+)$/;

export const generateNextColorKey = (customColors: Record<string, string>) => {
  const nextColorNum =
    Object.keys(customColors).reduce((max, key) => {
      const match = CUSTOM_COLOR_REGEX.exec(key);
      return match ? Math.max(max, Number(match[1])) : max;
    }, 0) + 1;

  return `color-${nextColorNum}`;
};
